// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AddressValidationModel from '../../model/address-validation-model';
import AddressValidationDTO from '../dto/address-validation-dto';
import dtoSchema from '../schemas/address-validation-schema';
import AddressModel from '../../model/address-model';

export default abstract class AddressValidationModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AddressValidationDTO>) {
    super();
    if (data) {
      this.addresses = data.addresses?.map((i) => AddressModel.toModel(i)) ?? [];
      this.isCountrySupported = data.isCountrySupported;
    }
  }
  /**
  */
  addresses?: AddressModel[];
  /**
  */
  isCountrySupported?: boolean;

  static toModel(dto: DeepPartial<AddressValidationDTO>): AddressValidationModel;
  static toModel(dto: DeepPartial<AddressValidationDTO> | undefined | null): AddressValidationModel | undefined;
  static toModel(dto: DeepPartial<AddressValidationDTO> | undefined | null): AddressValidationModel | undefined {
    return dto ? new AddressValidationModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AddressValidationModel> | AddressValidationModel): AddressValidationDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      addresses: unwrapped.addresses,
      isCountrySupported: unwrapped.isCountrySupported,
    } as AddressValidationDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AddressValidationModel, can not map to AddressValidationDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
